import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppAnimations } from 'src/app/_shared/animations';
import { KeyName} from 'src/app/app.keynames';
import { NewNotificationsComponent } from '../new-notifications.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'dialog-new-notifications',
  templateUrl: './dialog-new-notifications.component.html',
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' }
})
export class DialogNewNotificationsComponent {
  disableButton: boolean = false;
  isUpdate = false;
  @ViewChild(NewNotificationsComponent) _newNotificationsComponent: NewNotificationsComponent;
  formData: any;
  fromFieldControl = new FormControl();
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<DialogNewNotificationsComponent>,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    ) {
      this.iconRegistry.addSvgIcon('ico-close', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
      if(data.notificationData){
        this.isUpdate = true;
        this.fromFieldControl.setValue(data.notificationData.channel.companyNotificationTemplate.from)
        this.formData = {
          channelId: data.notificationData.channel.keyName,
          systemEventId: data.notificationData.notification.systemEvent?.id,
          companyIntegrationId: data.notificationData.channel.companyIntegration?.id,
        }
      }
    }

  onClose(): void {
    this._dialogRef.close();
  }

  onGetData(_data: any) {
    _data.bodyParams.from = this.fromFieldControl.value; // custom form field
    this._dialogRef.close({ code: KeyName.request_success, data: _data});
  }

  onGetDisableButton(value: boolean) {
    this.disableButton = value;
  }

  onSubmit(): void {
    this._newNotificationsComponent.setData();
  }
}
